const ADD_VISITED_VIEWS = "ADD_VISITED_VIEWS";
const DEL_VISITED_VIEWS = "DEL_VISITED_VIEWS";
const SAVE_CURCON_TEXT_TABID = "SAVE_CURCON_TEXT_TABID";
const CLOSE_ALL_TABS = "CLOSE_ALL_TABS";
const CLOSE_OTHER_TABS = "CLOSE_OTHER_TABS";
const SWITCH_TAB = "SWITCH_TAB";
const RESET_STATE = "RESET_STATE";

import router from "@/router";

const INIT_STATE = {
    editableTabs: [],
    editableTabsValue: "",
    curContextTabId: "",
    nextTab: {},
};
const tagsview = {
    namespaced: true,
    state: {
        editableTabs: [], //存放所有浏览过的且不重复的路由数据
        editableTabsValue: "",
        curContextTabId: "",
        nextTab: {},
    },
    mutations: {
        // 重置所有状态
        [RESET_STATE](state, initState) {
            if (initState) {
                /**
                 * 注：如果目标对象与源对象有同名属性，或多个源对象有同名属性，则后面的属性会覆盖前面的属性
                 * Object.assign方法用来将源对象（source）的所有可枚举属性，复制到目标对象（target）。
                 *  */
                Object.assign(state, initState);
            }
        },
        [ADD_VISITED_VIEWS]: (state, route) => {
            //打开新页签--添加路由数据的方法
            if (state.editableTabs.some(v => v.path == route.path)) return;
            state.editableTabs.push({
                title: route.name,
                name: route.name,
                path: route.path,
                params: route.params,
                query: route.query
            });
        },
        [DEL_VISITED_VIEWS]: (state, targetName) => {
            //关闭页签--删除路由数据的方法
            let activeName = state.editableTabsValue;
            let tabs = state.editableTabs;
            state.nextTab = {}
            if (activeName === targetName) {
                tabs.forEach((tab, index) => {
                    if (tab.name === targetName) {
                        state.nextTab = tabs[index + 1] || tabs[index - 1];
                        if (JSON.stringify(state.nextTab)!=='{}') {
                            activeName = state.nextTab.name;
                        }
                    }
                });
            }
            state.editableTabsValue = activeName;
            state.editableTabs = tabs.filter(tab => tab.name !== targetName);
        },
        [SWITCH_TAB](state, editableTabsValue) {
            state.editableTabsValue = editableTabsValue;
        },
        // 保存右键点击tab的id
        [SAVE_CURCON_TEXT_TABID](state, curContextTabId) {
            state.curContextTabId = curContextTabId;
        },
        // 关闭所有标签
        [CLOSE_ALL_TABS](state) {
            state.editableTabs = [];
        },
        // 关闭其它标签页
        [CLOSE_OTHER_TABS](state, par) {
            let editableTabs = state.editableTabs;
            let length = editableTabs.length;
            let curContextTabId = state.curContextTabId;
            let editableTabsValue = state.editableTabsValue;
            let id; // 右键点击时的tab在整个editableTabs数组中的id
            let curId; // 左键点击时的tab在整个editableTabs数组中的id
            editableTabs.forEach((tab, index) => {
                if (tab.name == curContextTabId) {
                    id = index;
                }
                if (tab.name == editableTabsValue) {
                    curId = index;
                }
            });
            //  console.log(id, curId)
            //  return
            if (par == "left") {
                let activeTabItem = editableTabs[id]
                state.editableTabs = state.editableTabs.slice(id, length);
                if (id > curId) {
                    state.editableTabsValue = curContextTabId;
                    routerFun(activeTabItem);
                }
            }
            if (par == "right") {
                let activeTabItem = editableTabs[id]
                state.editableTabs = state.editableTabs.slice(0, id + 1);
                if (id < curId) {
                    state.editableTabsValue = curContextTabId;
                    routerFun(activeTabItem);
                }
            }
            if (par == "other") {
                routerFun(editableTabs[id]);
                state.editableTabsValue = curContextTabId;
                state.editableTabs = [state.editableTabs[id]];
            }
            function routerFun(t) {
                if (JSON.stringify(t.params) == "{}") {
                    router.push({
                        path: t.path,
                        query: t.query
                    });
                } else {
                    router.push({
                        name: t.name,
                        params: t.params
                    });
                }
            }
        }
    },
    actions: {
        // 重置所有状态
        resetState({ commit }) {
            commit(RESET_STATE, INIT_STATE);
        },
        //调用这里去触发mutations，如何调用？在组件内使用this.$store.dispatch('action中对应名字', 参数)
        addVisitedViews({ commit }, route) {
            //通过解构赋值得到commit方法
            commit(ADD_VISITED_VIEWS, route);
            commit(SWITCH_TAB, route.name);
        },
        delVisitedViews({ commit, state }, targetName) {
            if (!targetName) {
                targetName = state.curContextTabId;
            }
            commit(DEL_VISITED_VIEWS, targetName);
        },
        saveCurContextTabId({ commit }, name){
            commit(SAVE_CURCON_TEXT_TABID, name);
        },
        closeAllTabs({ commit }){
            commit(CLOSE_ALL_TABS);
        },
        closeOtherTabs({ commit },par){
            commit(CLOSE_OTHER_TABS,par);
        },
    }
};
export default tagsview;



// WEBPACK FOOTER //
// ./src/vuex/modules/tagsview.js